"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PatientAccountInfo;
require("antd/lib/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EditableNickName = require("../../EditableNickName");
var _EditableEmail = require("../../EditableEmail");
var _components = require("../../../components");
var _utils = require("../../../utils");
var _PatientInfoItem = require("../PatientInfoItem");
var _PatientInfoCard = require("../PatientInfoCard");
var _AccountChatBanConfig = _interopRequireDefault(require("./components/AccountChatBanConfig"));
var _EmployerSelectorWithHistory = require("./components/EmployerSelectorWithHistory");
require("../PatientInfo.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PatientAccountInfo(props) {
  var _props$isSuperAdmin = props.isSuperAdmin,
    isSuperAdmin = _props$isSuperAdmin === void 0 ? false : _props$isSuperAdmin,
    _props$patient = props.patient,
    patient = _props$patient === void 0 ? {} : _props$patient,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Account Info' : _props$title,
    handleDosespotUserCreation = props.handleDosespotUserCreation,
    handleChatSync = props.handleChatSync,
    handleSimulateUser = props.handleSimulateUser,
    onNickNameSubmit = props.onNickNameSubmit,
    onEmailSubmit = props.onEmailSubmit,
    onTogglePatientActivated = props.onTogglePatientActivated;
  var nickName = patient.nickName,
    email = patient.email,
    address = patient.address,
    createdAt = patient.createdAt,
    erxId = patient.erxId,
    medicalRecordNumber = patient.medicalRecordNumber,
    insurancePayerName = patient.insurancePayerName,
    status = patient.status;
  var isPatientDeactivated = status === _utils.AccountStatus.Deactivated;
  return /*#__PURE__*/_react.default.createElement(_PatientInfoCard.PatientInfoCard, {
    title: title,
    actionContent: /*#__PURE__*/_react.default.createElement(_AccountChatBanConfig.default, {
      patientId: patient.id,
      title: "Public Chat ban settings"
    })
  }, /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Nickname:",
    value: /*#__PURE__*/_react.default.createElement(_EditableNickName.EditableNickName, {
      nickName: nickName,
      onSubmit: onNickNameSubmit
    })
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Email:",
    value: /*#__PURE__*/_react.default.createElement(_EditableEmail.EditableEmail, {
      email: email,
      onSubmit: onEmailSubmit
    })
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "State:",
    value: address === null || address === void 0 ? void 0 : address.state
  }), insurancePayerName && /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Payer:",
    value: insurancePayerName
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Medical Record Number (MRN):",
    value: medicalRecordNumber
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Member since:",
    value: (0, _utils.formatDate)(createdAt)
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Employer",
    value: /*#__PURE__*/_react.default.createElement(_EmployerSelectorWithHistory.EmployerSelectorWithHistory, {
      patient: patient
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "patient-actions"
  }, isSuperAdmin && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isPatientDeactivated && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    placement: "top",
    title: "Navigate to Patient application"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    icon: "info",
    onClick: handleSimulateUser
  }, "Simulate Patient")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    placement: "top",
    title: "Control patient account (Auth0) status, deactivated members can not login in application"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    icon: "info",
    onClick: onTogglePatientActivated
  }, isPatientDeactivated ? 'Reactivate' : 'Deactivate', " Patient"))), !erxId && /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    onClick: handleDosespotUserCreation
  }, "Create Dosespot Account"), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    placement: "top",
    title: "Synchronize Patient Clinician Chats in case something went wrong during clinician rematch"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    icon: "info",
    onClick: handleChatSync
  }, "Synchronize chats"))));
}
PatientAccountInfo.propTypes = {
  title: _propTypes.default.string,
  isSuperAdmin: _propTypes.default.bool,
  patient: _propTypes.default.shape({
    nickName: _propTypes.default.string,
    email: _propTypes.default.string,
    createdAt: _propTypes.default.string,
    address: _propTypes.default.shape({
      state: _propTypes.default.string
    })
  }),
  subscription: _propTypes.default.shape({
    price: _propTypes.default.any,
    renewDate: _propTypes.default.string,
    startDate: _propTypes.default.string,
    stripePlanId: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  bordered: _propTypes.default.bool,
  handleSimulateUser: _propTypes.default.func
};